import { Component, OnChanges, Input } from "@angular/core";

import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-mech-maintenance",
	templateUrl: "./mech-maintenance.component.html",
	styleUrls: ["./mech-maintenance.component.scss"]
})
export class MechMaintenanceComponent implements OnChanges {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;

	public logs: APIResults.MaintenanceHistory[];

	public allLRUs: AssemblyConfig.LRUDef[];

	public newDate: string;
	public newLRU: AssemblyConfig.LRUDef;
	public newSummary: string;

	constructor(public api: ApiService) { }

	async ngOnChanges() {
		this.allLRUs = [{
			id: null,
			name: "A/C (all components)",
		}, ...this.components.lru];
		this.newLRU = this.allLRUs[0];
		await this.updateLogs();
	}

	async updateLogs() {
		const result = await this.api.GetMaintenanceHistory(this.asset.asset_id);
		this.logs = result;
	}

	lookupLRU(id: number) {
		const lru = this.allLRUs.find(item => item.id === id);
		if (lru) {
			return lru.name;
		}
		return "????";
	}

	async UploadMaintenance() {
		const ts = this.newDate + "Z";
		await this.api.UploadMaintenance(this.asset.asset_id, ts, this.newLRU.id, this.newSummary);
		await this.updateLogs();
		this.newSummary = undefined;
	}

	async DeleteMaintenance(id: number) {
		await this.api.DeleteMaintenance(this.asset.asset_id, id);
		await this.updateLogs();
	}
}
